// extracted by mini-css-extract-plugin
module.exports = {"header":"hx","headerBg":"hy"};